// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"85":"mobile","339":"storefront","884":"admin"}[chunkId] || chunkId) + "." + {"73":"19c750e6","85":"faef613c","339":"9b8aa125","445":"5dcadcd8","556":"b2d7ef72","884":"90558700"}[chunkId] + ".chunk.js";
};